import { BaseReferralClient, InviteVariables, Invitation, DeleteInvitationVariables, ReferralStats, ReferralStatsResponse } from "@core/types";
import { convertToReferralStats } from "./converters";

class ReferralClient extends BaseReferralClient {
  async invite(variables: InviteVariables): Promise<any> {
    const { data } = await this.instance.post("/wp-json/parhato-api/v1/invitations", variables);

    return data;
  }

  async getInvitations(): Promise<Invitation[]> {
    const { data } = await this.instance.get("/wp-json/parhato-api/v1/invitations");

    return data;
  }

  async deleteInvitation(variables: DeleteInvitationVariables): Promise<any> {
    throw new Error("deleteInvitation not implemented");
  }

  async getReferralPoints(): Promise<number> {
    const { data } = await this.instance.get(`/wp-json/parhato-api/v1/referral-points`);
    return data.points;
  }

  async checkWasInvited(variables: InviteVariables): Promise<Invitation | null> {
    const { data } = await this.instance.post("/wp-json/parhato-api/v1/invitations/check", variables);

    if (Array.isArray(data) && data.length > 0) {
      return data[0];
    } else if (data) {
      return data;
    }

    return null;
  }

  async getReferralStats(referralId: string): Promise<ReferralStats | null> {
    const { data } = await this.instance.get<ReferralStatsResponse>(`/wp-json/parhato-api/v1/invitations/stats?referralId=${referralId}`);
    return data ? convertToReferralStats(data) : null;
  }
}

export default ReferralClient;
